// extracted by mini-css-extract-plugin
export default {"tag":"JobPositionAuthorizedUsers-index__tag--QwXFJ"};